import { Base } from '@itsrever/design-system'

interface ProductTagProps {
  label: string
}

export const ProductTag: React.FC<ProductTagProps> = ({ label }) => (
  <Base.Badge variant="outline">{label}</Base.Badge>
)
